export default "__VITE_ASSET__9268da79__"